// If a WP theme or plugin also uses Handlebars, don't overwrite that with
// our Handlebars instance. Instead, our Handlebars instance will always live
// in the AsteikkoHandlebars variable.

window.AsteikkoHandlebars = Handlebars;
Handlebars.noConflict();
